// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__geNdC","slider":"ToggleSwitch_slider__P8zew","on":"ToggleSwitch_on__JzqL4","off":"ToggleSwitch_off__SH9Mv","round":"ToggleSwitch_round__m5nTs"};